import { css as s } from "styled-components";
const e = {
  base: ({ theme: o }) => /* @__PURE__ */ s([
    "border:0.2rem solid ",
    ";padding:",
    ";padding-top:0;"
  ], o.componentColors.forms.fieldset.border, o.space.sm)
};
export {
  e as default
};
